var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_141)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.0394,
    y: 10.2131,
    width: 59.64,
    height: 59.64,
    rx: 29.82,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.4838 51.7061C55.4838 52.9942 55.007 54.1234 54.2414 54.9896C54.2324 54.9998 54.2261 55.0122 54.2233 55.0256C54.2118 55.081 54.2611 55.1297 54.3157 55.1162C56.5232 54.5688 58.3081 52.6711 58.3081 50.1791V37.2602C58.3081 33.4413 56.1886 29.9125 52.7478 28.0031L38.8549 20.2931L36.1028 21.8602L49.9236 29.5301C53.3643 31.4396 55.4838 34.9684 55.4838 38.7873V51.7061Z",
    fill: "url(#paint0_linear_2_141)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4838 51.7061C55.4838 52.9942 55.007 54.1234 54.2414 54.9896C54.2324 54.9998 54.2261 55.0122 54.2233 55.0256C54.2118 55.081 54.2611 55.1297 54.3157 55.1162C56.5232 54.5688 58.3081 52.6711 58.3081 50.1791V37.2602C58.3081 33.4413 56.1886 29.9125 52.7478 28.0031L38.8549 20.2931L36.1028 21.8602L49.9236 29.5301C53.3643 31.4396 55.4838 34.9684 55.4838 38.7873V51.7061Z",
    fill: "url(#paint1_linear_2_141)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4838 51.7061C55.4838 52.9942 55.007 54.1234 54.2414 54.9896C54.2324 54.9998 54.2261 55.0122 54.2233 55.0256C54.2118 55.081 54.2611 55.1297 54.3157 55.1162C56.5232 54.5688 58.3081 52.6711 58.3081 50.1791V37.2602C58.3081 33.4413 56.1886 29.9125 52.7478 28.0031L38.8549 20.2931L36.1028 21.8602L49.9236 29.5301C53.3643 31.4396 55.4838 34.9684 55.4838 38.7873V51.7061Z",
    fill: "url(#paint2_radial_2_141)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4838 51.7061C55.4838 52.9942 55.007 54.1234 54.2414 54.9896C54.2324 54.9998 54.2261 55.0122 54.2233 55.0256C54.2118 55.081 54.2611 55.1297 54.3157 55.1162C56.5232 54.5688 58.3081 52.6711 58.3081 50.1791V37.2602C58.3081 33.4413 56.1886 29.9125 52.7478 28.0031L38.8549 20.2931L36.1028 21.8602L49.9236 29.5301C53.3643 31.4396 55.4838 34.9684 55.4838 38.7873V51.7061Z",
    fill: "url(#paint3_radial_2_141)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4838 51.7061C55.4838 52.9942 55.007 54.1234 54.2414 54.9896C54.2324 54.9998 54.2261 55.0122 54.2233 55.0256C54.2118 55.081 54.2611 55.1297 54.3157 55.1162C56.5232 54.5688 58.3081 52.6711 58.3081 50.1791V37.2602C58.3081 33.4413 56.1886 29.9125 52.7478 28.0031L38.8549 20.2931L36.1028 21.8602L49.9236 29.5301C53.3643 31.4396 55.4838 34.9684 55.4838 38.7873V51.7061Z",
    fill: "url(#paint4_linear_2_141)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6005 53.9118V40.993C51.6005 37.1741 49.4809 33.6452 46.0402 31.7358L32.2195 24.0659L34.9716 22.4988L48.8645 30.2087C52.3052 32.1182 54.4248 35.647 54.4248 39.4659V52.3848C54.4248 54.8768 52.6399 56.7745 50.4324 57.3219C50.3778 57.3354 50.3285 57.2866 50.34 57.2313C50.3428 57.2179 50.3491 57.2055 50.3581 57.1952C51.1237 56.3291 51.6005 55.1999 51.6005 53.9118Z",
    fill: "url(#paint5_linear_2_141)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6005 53.9118V40.993C51.6005 37.1741 49.4809 33.6452 46.0402 31.7358L32.2195 24.0659L34.9716 22.4988L48.8645 30.2087C52.3052 32.1182 54.4248 35.647 54.4248 39.4659V52.3848C54.4248 54.8768 52.6399 56.7745 50.4324 57.3219C50.3778 57.3354 50.3285 57.2866 50.34 57.2313C50.3428 57.2179 50.3491 57.2055 50.3581 57.1952C51.1237 56.3291 51.6005 55.1999 51.6005 53.9118Z",
    fill: "url(#paint6_linear_2_141)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6005 53.9118V40.993C51.6005 37.1741 49.4809 33.6452 46.0402 31.7358L32.2195 24.0659L34.9716 22.4988L48.8645 30.2087C52.3052 32.1182 54.4248 35.647 54.4248 39.4659V52.3848C54.4248 54.8768 52.6399 56.7745 50.4324 57.3219C50.3778 57.3354 50.3285 57.2866 50.34 57.2313C50.3428 57.2179 50.3491 57.2055 50.3581 57.1952C51.1237 56.3291 51.6005 55.1999 51.6005 53.9118Z",
    fill: "url(#paint7_radial_2_141)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6005 53.9118V40.993C51.6005 37.1741 49.4809 33.6452 46.0402 31.7358L32.2195 24.0659L34.9716 22.4988L48.8645 30.2087C52.3052 32.1182 54.4248 35.647 54.4248 39.4659V52.3848C54.4248 54.8768 52.6399 56.7745 50.4324 57.3219C50.3778 57.3354 50.3285 57.2866 50.34 57.2313C50.3428 57.2179 50.3491 57.2055 50.3581 57.1952C51.1237 56.3291 51.6005 55.1999 51.6005 53.9118Z",
    fill: "url(#paint8_radial_2_141)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6005 53.9118V40.993C51.6005 37.1741 49.4809 33.6452 46.0402 31.7358L32.2195 24.0659L34.9716 22.4988L48.8645 30.2087C52.3052 32.1182 54.4248 35.647 54.4248 39.4659V52.3848C54.4248 54.8768 52.6399 56.7745 50.4324 57.3219C50.3778 57.3354 50.3285 57.2866 50.34 57.2313C50.3428 57.2179 50.3491 57.2055 50.3581 57.1952C51.1237 56.3291 51.6005 55.1999 51.6005 53.9118Z",
    fill: "url(#paint9_linear_2_141)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1595 26.3768L30.9475 24.7893L44.8404 32.4993C48.2812 34.4087 50.4007 37.9375 50.4007 41.7565V54.739L50.4004 54.7388C50.353 58.62 45.9687 61.0321 42.4575 59.0835L29.8659 52.0957L28.1595 51.1731V26.3768ZM47.5764 43.3238V50.8237L38.221 45.6318V31.9605L42.0162 34.0667C45.4569 35.9761 47.5764 39.5049 47.5764 43.3238ZM34.6907 30.0013L36.1028 30.785V46.8066L36.2511 46.8866L47.5764 53.1716V54.6226L34.7089 47.4816L34.6907 47.492V30.0013ZM32.396 28.7278V48.7244L32.4623 48.7609L32.396 48.7987L47.5591 57.2135C47.4324 57.8847 46.6358 58.2676 45.9878 57.908L30.9838 49.5814V27.9442L32.396 28.7278Z",
    fill: "url(#paint10_linear_2_141)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1595 26.3768L30.9475 24.7893L44.8404 32.4993C48.2812 34.4087 50.4007 37.9375 50.4007 41.7565V54.739L50.4004 54.7388C50.353 58.62 45.9687 61.0321 42.4575 59.0835L29.8659 52.0957L28.1595 51.1731V26.3768ZM47.5764 43.3238V50.8237L38.221 45.6318V31.9605L42.0162 34.0667C45.4569 35.9761 47.5764 39.5049 47.5764 43.3238ZM34.6907 30.0013L36.1028 30.785V46.8066L36.2511 46.8866L47.5764 53.1716V54.6226L34.7089 47.4816L34.6907 47.492V30.0013ZM32.396 28.7278V48.7244L32.4623 48.7609L32.396 48.7987L47.5591 57.2135C47.4324 57.8847 46.6358 58.2676 45.9878 57.908L30.9838 49.5814V27.9442L32.396 28.7278Z",
    fill: "url(#paint11_linear_2_141)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1595 26.3768L30.9475 24.7893L44.8404 32.4993C48.2812 34.4087 50.4007 37.9375 50.4007 41.7565V54.739L50.4004 54.7388C50.353 58.62 45.9687 61.0321 42.4575 59.0835L29.8659 52.0957L28.1595 51.1731V26.3768ZM47.5764 43.3238V50.8237L38.221 45.6318V31.9605L42.0162 34.0667C45.4569 35.9761 47.5764 39.5049 47.5764 43.3238ZM34.6907 30.0013L36.1028 30.785V46.8066L36.2511 46.8866L47.5764 53.1716V54.6226L34.7089 47.4816L34.6907 47.492V30.0013ZM32.396 28.7278V48.7244L32.4623 48.7609L32.396 48.7987L47.5591 57.2135C47.4324 57.8847 46.6358 58.2676 45.9878 57.908L30.9838 49.5814V27.9442L32.396 28.7278Z",
    fill: "url(#paint12_radial_2_141)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1595 26.3768L30.9475 24.7893L44.8404 32.4993C48.2812 34.4087 50.4007 37.9375 50.4007 41.7565V54.739L50.4004 54.7388C50.353 58.62 45.9687 61.0321 42.4575 59.0835L29.8659 52.0957L28.1595 51.1731V26.3768ZM47.5764 43.3238V50.8237L38.221 45.6318V31.9605L42.0162 34.0667C45.4569 35.9761 47.5764 39.5049 47.5764 43.3238ZM34.6907 30.0013L36.1028 30.785V46.8066L36.2511 46.8866L47.5764 53.1716V54.6226L34.7089 47.4816L34.6907 47.492V30.0013ZM32.396 28.7278V48.7244L32.4623 48.7609L32.396 48.7987L47.5591 57.2135C47.4324 57.8847 46.6358 58.2676 45.9878 57.908L30.9838 49.5814V27.9442L32.396 28.7278Z",
    fill: "url(#paint13_radial_2_141)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1595 26.3768L30.9475 24.7893L44.8404 32.4993C48.2812 34.4087 50.4007 37.9375 50.4007 41.7565V54.739L50.4004 54.7388C50.353 58.62 45.9687 61.0321 42.4575 59.0835L29.8659 52.0957L28.1595 51.1731V26.3768ZM47.5764 43.3238V50.8237L38.221 45.6318V31.9605L42.0162 34.0667C45.4569 35.9761 47.5764 39.5049 47.5764 43.3238ZM34.6907 30.0013L36.1028 30.785V46.8066L36.2511 46.8866L47.5764 53.1716V54.6226L34.7089 47.4816L34.6907 47.492V30.0013ZM32.396 28.7278V48.7244L32.4623 48.7609L32.396 48.7987L47.5591 57.2135C47.4324 57.8847 46.6358 58.2676 45.9878 57.908L30.9838 49.5814V27.9442L32.396 28.7278Z",
    fill: "url(#paint14_linear_2_141)",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_141",
    x: 0.439428,
    y: 0.973135,
    width: 84.84,
    height: 84.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.36
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_141"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_141",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_141",
    x1: 27.6575,
    y1: 40.0331,
    x2: 57.9749,
    y2: 37.3399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#711EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FE5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_141",
    x1: 30.0281,
    y1: 22.11,
    x2: 51.3049,
    y2: 40.0711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E07774",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.9544 34.1713) rotate(65.7206) scale(8.83444 7.54954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.925861,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.333 30.5101) rotate(59.1627) scale(5.604 7.63088)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0864251,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94115,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_141",
    x1: 31.6108,
    y1: 31.2587,
    x2: 47.3396,
    y2: 36.7763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_141",
    x1: 27.6576,
    y1: 40.0331,
    x2: 57.9749,
    y2: 37.3399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#711EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FE5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_141",
    x1: 30.0282,
    y1: 22.11,
    x2: 51.3049,
    y2: 40.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E07774",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.9544 34.1713) rotate(65.7206) scale(8.83444 7.54954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.925861,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3331 30.51) rotate(59.1627) scale(5.604 7.63088)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0864251,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94115,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_141",
    x1: 31.6109,
    y1: 31.2587,
    x2: 47.3396,
    y2: 36.7763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_141",
    x1: 27.6575,
    y1: 40.033,
    x2: 57.9749,
    y2: 37.3399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#711EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FE5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_141",
    x1: 30.0281,
    y1: 22.11,
    x2: 51.3049,
    y2: 40.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E07774",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.9544 34.1713) rotate(65.7206) scale(8.83444 7.54954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.925861,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3331 30.51) rotate(59.1627) scale(5.604 7.63088)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0864251,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94115,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_141",
    x1: 31.6109,
    y1: 31.2587,
    x2: 47.3396,
    y2: 36.7762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_141"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.1595,
    y: 20.2931,
    width: 30.24,
    height: 39.48,
    rx: 15.12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrift);
export default __webpack_public_path__ + "static/media/drift.18c22cffc32b61df51a53da154aa9b49.svg";
export { ForwardRef as ReactComponent };